export const NOT_CHANGABLE_TEXT = "Kontakta PREMA om uppgiften behöver ändras"